import { mapGetters } from 'vuex';
import { lockScroll, unlockScroll } from '@/utils/helpers';

export default {
  props: {
    value: {
      type: Number,
      default: 50,
    },
    userQuantity: {},
    operationType: {
      type: String,
      default: 'buy',
    },
    tabindex: Number,
    minimumOwnership: {
      type: Number,
      default: 1,
    },
    minValue: {
      type: Number,
      default: 1,
    },
    maxValue: {
      type: Number,
      default: 9999,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      updated: false,
      val: this.value !== null ? parseInt(this.value, 10) : null,
      options: [-10, -1, 1, 10, 100],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
  watch: {
    val: 'updateOffer',
    value(value) {
      this.val = value !== null ? parseInt(value, 10) : null;
    },
  },
  methods: {
    onSelectOption(option) {
      this.add(option);
    },
    add(value) {
      if (isNaN(this.val) || this.val === null) {
        this.val = 0;
      }
      let newValue = this.val + value;
      if (
        this.userQuantity &&
        this.operationType === 'sell' &&
        this.val <= this.userQuantity &&
        newValue > this.userQuantity
      ) {
        newValue = this.userQuantity;
      }
      this.val = Math.max(Math.min(newValue, this.maxValue), this.minValue);
    },
    updateOffer() {
      this.updated = true;
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    onFocus() {
      if (this.isLayoutMobile) {
        lockScroll();
      }
      this.$emit('focus');
      const focusAndSelect = () => {
        const el = this.$refs && this.$refs.input;
        if (el && typeof el.select === 'function') {
          el.focus();
          el.select();
          el.setSelectionRange(0, 9999);
        }
      };
      this.$nextTick(focusAndSelect);
      setTimeout(focusAndSelect, 50);
    },
    onBlur() {
      this.$emit('blur', this.val);
      if (this.isLayoutMobile) {
        unlockScroll();
      }
    },
  },
  beforeDestroy() {
    if (this.isLayoutMobile) {
      unlockScroll();
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-quantity-picker-mobile-sushi/purchase-quantity-picker-mobile-sushi.js